import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { CourseModal } from './CourseModal';

export const CourseNode = ({ course, variant = 'default', onClick, badge }) => (
  <button
    type="button"
    data-testid={`course-node-${course.slug}`}
    data-variant={variant}
    className="course-node block w-full text-left group"
    onClick={() => onClick && onClick(course)}
  >
    <div className="flex items-start justify-between gap-2">
      <div className="font-display text-sm sm:text-[15px] font-semibold leading-tight">{course.short_name || course.name}</div>
      {badge && <span className="text-[9px] uppercase tracking-[0.18em] px-1.5 py-0.5 rounded-full bg-white/8 text-white/55 shrink-0">{badge}</span>}
    </div>
    <div className="mt-1 text-[11px] text-white/55">Click to view details</div>
  </button>
);

export const FlowchartFrame = ({ children, title, subtitle }) => (
  <div className="relative">
    {(title || subtitle) && (
      <div className="mb-6">
        {title && <div className="font-display text-base sm:text-lg font-semibold text-white">{title}</div>}
        {subtitle && <div className="text-xs text-white/55 mt-0.5">{subtitle}</div>}
      </div>
    )}
    <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-4 sm:p-6">
      {children}
    </div>
  </div>
);

// Vertical chain with connector lines drawn via CSS pseudo-elements (lightweight, no refs)
export const VerticalChain = ({ courses, onClick, variant }) => (
  <ol className="relative space-y-3">
    {courses.map((c, i) => (
      <li key={c.id || c.slug} className="relative">
        {i > 0 && (
          <div aria-hidden className="pointer-events-none absolute left-1/2 -top-3 -translate-x-1/2 h-3 w-px bg-gradient-to-b from-[#00b4d8]/0 to-[#00b4d8]/80" />
        )}
        <CourseNode course={c} variant={variant} onClick={onClick} />
      </li>
    ))}
  </ol>
);

export const useCourseModal = () => {
  const [open, setOpen] = useState(false);
  const [course, setCourse] = useState(null);
  const openCourse = (c) => { setCourse(c); setOpen(true); };
  return { open, setOpen, course, openCourse };
};
